/**
 * Copyright 2020-2026 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

import { InstrumentBase } from '../../utils/instrument-base';
import { FEATURE_NAME } from '../constants';
export class Instrument extends InstrumentBase {
  static featureName = FEATURE_NAME;
  constructor(agentRef) {
    super(agentRef, FEATURE_NAME);
    this.importAggregator(agentRef, () => import(/* webpackChunkName: "metrics-aggregate" */'../aggregate'));
  }
}
export const Metrics = Instrument;